import React from 'react';
import { Empty} from 'antd';
import noDataPng from '../../containers/images/noData.png';

export default function() {
    return <Empty image ={noDataPng}  description = "当前暂无上传文件" />;
}